import { useMutation, useQueryClient } from "react-query";
import { denyInvoice } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";
import { toast } from "../../../../../components/toastNotification";

export const useDenyInvoiceDetails = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (ids: number[] | undefined) => denyInvoice(ids),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["GetForReviewInvoices"]);

        toast.fire(
          "Success",
          "Vendor invoice has been denied successfully",
          "success"
        );
      },

      onError: () => {
        toast.fire(
          "Bulk Deny of Vendor Invoice failed",

          "Server Error: Cannot Deny Vendor Invoice",

          "error"
        );
      },
    }
  );

  return mutate;
};
